/*
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2.09961C17.4676 2.09961 21.9004 6.53238 21.9004 12C21.9004 17.4676 17.4676 21.9004 12 21.9004C6.53238 21.9004 2.09961 17.4676 2.09961 12C2.09961 6.53238 6.53238 2.09961 12 2.09961Z" fill="#FF2DA1"/>
<path d="M14.8633 8.86346C15.2148 8.51199 15.7853 8.51199 16.1368 8.86346C16.4882 9.21493 16.4882 9.78545 16.1368 10.1369L11.1368 15.1369C10.7853 15.4883 10.2148 15.4883 9.86334 15.1369L7.86334 13.1369C7.51186 12.7854 7.51186 12.2149 7.86334 11.8635C8.21481 11.512 8.7853 11.512 9.13677 11.8635L10.5001 13.2267L14.8633 8.86346Z" fill="white"/>
</svg>
*/

export const CheckedSvg = (props: {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}) => {
  const { onClick } = props
  return (
    <div onClick={onClick}>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M12 2.09961C17.4676 2.09961 21.9004 6.53238 21.9004 12C21.9004 17.4676 17.4676 21.9004 12 21.9004C6.53238 21.9004 2.09961 17.4676 2.09961 12C2.09961 6.53238 6.53238 2.09961 12 2.09961Z'
          fill='#FF2DA1'
        />
        <path
          d='M14.8633 8.86346C15.2148 8.51199 15.7853 8.51199 16.1368 8.86346C16.4882 9.21493 16.4882 9.78545 16.1368 10.1369L11.1368 15.1369C10.7853 15.4883 10.2148 15.4883 9.86334 15.1369L7.86334 13.1369C7.51186 12.7854 7.51186 12.2149 7.86334 11.8635C8.21481 11.512 8.7853 11.512 9.13677 11.8635L10.5001 13.2267L14.8633 8.86346Z'
          fill='white'
        />
      </svg>
    </div>
  )
}
